import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import Text from '../../../Text'

import * as styles from './EmailMessageDragOverlay.module.css'

function EmailMessageDragOverlay({
  children,
  className = styles.EmailMessageDragOverlay,
  isDragging,
  isOver,
  onDragLeave,
}) {
  const { t } = useTranslation()

  const draggingClassName = classNames(styles.dragging, {
    [styles.over]: isOver,
  })
  const textClassName = classNames({ [styles.text]: isOver })

  return (
    <div className={className} onDragLeaveCapture={onDragLeave}>
      <div className={styles.content}>
        <div className={styles.shadow} />
        {children}
      </div>
      {isDragging ? (
        <div className={draggingClassName}>
          <Text isSecondary className={textClassName}>
            {t('Email.DropAsImageInTextKey')}
          </Text>
        </div>
      ) : null}
    </div>
  )
}

export default EmailMessageDragOverlay
